import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
import { Button, Form } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import QRCode from 'react-qr-code'
import { client } from '@utils/client'
import Modal from '@components/Modal'

const QrCode = (props) => {
  const { setModalQrCodeOpen, modalQrCodeOpen, qrCodeData } = props
  const { t } = useLocalization()

  const [imageId, setImageId] = useState()
  const [qrData, setQrData] = useState({})

  useEffect(() => {
    const fetch = async () => {
      let result = await client
        .get(`/special-event/${qrCodeData}/qr-data`)
        .then((res) => res.data)

      setQrData(result)
      return result
    }
    if (qrCodeData) {
      setImageId(qrCodeData)
      fetch()
    }
  }, [qrCodeData])

  const onImageDownload = () => {
    const svg = document.getElementById(`QRCode_${imageId}`)

    if (svg) {
      const svgData = new XMLSerializer().serializeToString(svg)
      const qrcanvas = document.createElement('canvas')
      const ctx =
        qrcanvas === null || qrcanvas === void 0
          ? void 0
          : qrcanvas.getContext('2d')
      const img = new Image()
      img.onload = () => {
        qrcanvas.width = 200
        qrcanvas.height = 200
        if (ctx) {
          ctx.fillStyle = '#fff'
          ctx.rect(0, 0, 200, 200)
          ctx.fill()
        }
        ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(img, 10, 10)
        const jpegFile = qrcanvas.toDataURL()

        const downloadLink = document.createElement('a')
        downloadLink.download = `QRCode_${imageId}`
        downloadLink.href = `${jpegFile}`
        downloadLink.click()
      }
      img.src = `data:image/svg+xml;base64,${btoa(svgData)}`
    }
  }

  const style = {
    btnStyledownload: {
      height: '37px',
      width: '176px',
      borderRadius: '8px',
      border: '1px solid #56B9C3',
    },
    btnStyleCancel: {
      height: '37px',
      width: '176px',
      borderRadius: '8px',
      border: '1px solid #56B9C3',
      color: '#56B9C3',
    },
  }
  const tailLayout = {
    wrapperCol: {
      span: 20,
      offset: 2,
    },
  }

  return (
    <>
      <Modal
        borderRadius
        centered={true}
        title={t('rewards.specialEvent.qrCode.qrCodeLabel')}
        open={modalQrCodeOpen}
        onCancel={() => setModalQrCodeOpen(false)}
        maskClosable={false}
        footer={null}
        width={500}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <QRCode
            id={`QRCode_${imageId}`}
            value={JSON.stringify(qrData)}
            size={180}
            fill="white"
          />
        </div>

        <Form.Item {...tailLayout}>
          <div style={{ textAlign: 'center' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-evenly',
                margin: '30px 0px 0px',
              }}
            >
              <Button
                htmlType="button"
                onClick={() => setModalQrCodeOpen(false)}
                style={style.btnStyleCancel}
              >
                {t('rewards.specialEvent.qrCode.close')}
              </Button>
              <Button
                icon={<DownloadOutlined style={{ fontSize: '20px' }} />}
                type="primary"
                htmlType="button"
                style={style.btnStyledownload}
                onClick={() => onImageDownload()}
              >
                {t('rewards.specialEvent.qrCode.download')}
              </Button>
            </div>
          </div>
        </Form.Item>
      </Modal>
    </>
  )
}

QrCode.propTypes = {
  qrCodeData: PropTypes.any,
  setModalQrCodeOpen: PropTypes.func,
  modalQrCodeOpen: PropTypes.bool,
}

export default QrCode
